module fdm.general {

    angular.module('fdm.general', []);
}